import CustomLoader from "Components/CustomComponents/CustomLoader";
import NoDataFound from "Components/CustomComponents/NoDataFound";
import { useLazyGetPendingRoutesQuery } from "Data/services/routesApi";
import { getCurrentDate } from "Helper";
import { useEffect, useState } from "react";
import CurrentDriverRoute from "./CurrentDriverRoute";
import { Routes } from "Data/interfaces";

const PendingComponent: React.FC = () => {
  const [selectedDate] = useState<string>(getCurrentDate());
  const [routes, setRoutes] = useState<Routes[]>([]);
  const [getPendingRoutes, { isFetching }] = useLazyGetPendingRoutesQuery();

  useEffect(() => {
    if (selectedDate) {
      getPendingRoutes({ date: selectedDate }).then(({ data }) => {
        setRoutes(data?.data || []);
      });
    }
  }, [selectedDate]);

  return (
    <div className="d-flex flex-column gap-2 mt-2">
      {isFetching && routes.length === 0 && <CustomLoader />}
      {!isFetching && routes.length === 0 && <NoDataFound />}

      {routes.map((route, index) => {
        return <CurrentDriverRoute key={index} route={route} pending={true} />;
      })}
    </div>
  );
};

export default PendingComponent;
